import { URLS } from 'config';
import * as R from 'ramda';
import { ApiMutationConfig, ApiQueryConfig } from '../types';
import { createApiEndpoint } from '../utils';

type PartnerPathParams = { $partnerId: number };
type GetPartnerIconResponse = string | null;
type GetPartnerIconConfig = ApiQueryConfig<
  GetPartnerIconResponse,
  PartnerPathParams
>;

const url = `${URLS.app}/api/Organizations/$partnerId/Logo`;

export const getPartnerIcon = createApiEndpoint<GetPartnerIconConfig>({
  method: 'GET',
  url,
  select: R.when(
    R.allPass([R.is(String), R.pipe(R.isEmpty, R.not)]),
    R.concat('data:image/jpg;base64, '),
  ),
  // this is used a lot, so we don't want to refetch contantly
  // it will be invalidated if the current user makes any changes
  staleTime: 1000 * 60 * 60,
});

type PostPartnerIconConfig = ApiMutationConfig<FormData, PartnerPathParams>;

export const postPartnerIcon = createApiEndpoint<PostPartnerIconConfig>({
  method: 'POST',
  url,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
